module.exports = __webpack_public_path__ + "img/publication-placeholder.abec227e.jpg";